import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import type { KpiResponse, PaymentsScopeParams } from "../../domain/models/PaymentsKpi";
import { paymentsService } from "@/services/paymentsService";
import { queryKeys } from "@/utils/queryKeys";
export const usePaymentsKpi = t0 => {
  const $ = _c(9);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const params = t1;
  let t2;
  if ($[2] !== params) {
    t2 = queryKeys.payments.kpi(params);
    $[2] = params;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== params) {
    t3 = () => paymentsService.getKpi(params);
    $[4] = params;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = {
      queryKey: t2,
      queryFn: t3
    };
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return useQuery(t4);
};